import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import RefiMessages from 'src/Components/shared/InterestSection/RefiByYearsInHome/RefiMessages'
import RefiOptionCard from './RefiOptionCard'
import { Button, If, Unless } from 'src/Components'
import Block from './Block'
import Header from './Header'
import { ARM_MORTGAGE_TYPE } from 'src/constants/loan'

import styles from './RefiOption.module.scss'

const propTypes = {
  className: PropTypes.string,
  detail: PropTypes.shape({
    type: PropTypes.oneOf(['FIX', 'ARM']),
    years: PropTypes.number,
    rate: PropTypes.number,
    apr: PropTypes.number,
    longterm: PropTypes.number,
    shortterm: PropTypes.number
  }).isRequired,
  yearsInHome: PropTypes.number,
  pmi: PropTypes.number,
  horizontal: PropTypes.bool,
  onClick: PropTypes.func,
  locked: PropTypes.bool
}

const RefiOption = ({
  className,
  detail,
  yearsInHome,
  horizontal,
  onClick,
  locked,
  pmi,
  ...restProps
}) => {
  const handleClick = e => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <RefiOptionCard
      className={classnames(
        styles.card,
        horizontal && styles.horizontal,
        className
      )}
      data-qa={horizontal ? 'RefiOptionHorizontal' : 'RefiOption'}
      onClick={locked ? () => {} : handleClick}
      {...restProps}
    >
      <Header
        className={classnames(
          styles.header,
          detail.longterm < 0 && styles.headerNudge
        )}
        type={detail.type}
        years={detail.years}
        rate={detail.rate}
        apr={detail.apr}
        longterm={detail.longterm}
        caution={
          detail.type === ARM_MORTGAGE_TYPE && yearsInHome > detail.years
        }
        locked={locked}
      />
      <Block className={styles.body}>
        <RefiMessages.ShortBullets
          yearsInHome={yearsInHome}
          locked={locked}
          pmi={pmi}
          {...detail}
        />
      </Block>
      <Button
        data-qa='refi-more-details-button'
        className={!horizontal ? styles.minimalButton : styles.normalButton}
        minimal={!horizontal}
        onClick={!locked && handleClick}
      >
        <If condition={horizontal}>
          <FormattedMessage
            id='RefiOption.button.whatRate.wide'
            defaultMessage='What would your rate be?'
          />
        </If>
        <Unless condition={horizontal}>
          <FormattedMessage
            id='RefiOption.button.whatRate.narrow'
            defaultMessage='What’s your rate?'
          />
        </Unless>
      </Button>
    </RefiOptionCard>
  )
}

RefiOption.propTypes = propTypes

export default RefiOption
